export const common = {
  nav: {
    home: 'الرئيسية',
    features: 'المميزات',
    cases: 'حالات الذكاء الاصطناعي',
    workflow: 'سير العمل',
    contact: 'اتصل بنا',
    requestDemo: 'تجربة',
    demo: 'تجربة',
    predictions: 'التنبؤات',
  },
  hero: {
    title: 'تحليل الصور الطبية بالذكاء الاصطناعي',
    subtitle: 'نظام تصوير طبي ذكي شامل للتحليل التلقائي لحالات متعددة بما في ذلك الكسور والتهاب المفاصل وتشوهات الرئة والجنف والحالات السنية',
    cta: 'ابدأ الآن',
    fdaCompliant: 'متوافق مع FDA',
    hipaaSecure: 'آمن HIPAA',
    confidence: 'الثقة',
    detected: 'تم الكشف',
  },
  features: {
    label: 'القدرات الأساسية',
    title: 'تقنية الكشف المتقدمة متعددة الحالات',
    subtitle: 'الاستفادة من أحدث تقنيات الذكاء الاصطناعي والرؤية الحاسوبية لتقديم تحليل سريع ودقيق وشامل للصور الطبية عبر حالات طبية متعددة للمهنيين الصحيين في جميع أنحاء العالم.',
    
    fracture: {
      title: 'كشف كسور العظام',
      description: 'يكتشف بدقة أنواع متعددة من كسور العظام بما في ذلك كسور الكوع والمعصم والكتف والعضد والساعد والأصابع مع تحديد دقيق للموقع.',
      metric: '6 أنواع من الكسور',
    },
    knee: {
      title: 'كشف التهاب مفصل الركبة',
      description: 'تحليل متقدم لتدهور مفصل الركبة، وتحديد مستويات شدة التهاب المفاصل والكشف المبكر عن تدهور الغضروف.',
      metric: '5 درجات شدة',
    },
    lung: {
      title: 'كشف تشوهات الرئة',
      description: 'تحليل شامل للأشعة السينية للصدر يكتشف انخماص الرئة وتضخم القلب والانصباب الجنبي والارتشاحات والعقيدات والكتل والالتهاب الرئوي واسترواح الصدر بدقة عالية.',
      metric: '8 حالات',
    },
    scoliosis: {
      title: 'كشف الجنف',
      description: 'يحدد تشوهات انحناء العمود الفقري ومستويات الشدة من صور الأشعة السينية.',
      metric: '4 مناطق العمود الفقري',
    },
    teeth: {
      title: 'كشف الأسنان',
      description: 'يكتشف جميع حالات الأسنان بما في ذلك التسوس والتيجان والحشوات والزرعات وفقدان العظام وكسور الأسنان باستخدام صور الأشعة السينية مع نموذج YOLOv8.',
      metric: '31 حالة أسنان',
    },
    cavity: {
      title: 'كشف التجاويف',
      description: 'يركز بشكل خاص على اكتشاف التجاويف مقابل الأسنان الطبيعية باستخدام صور سريرية حقيقية مع نموذج YOLOv8. يدعم JPEG/PNG مع تصور مربع الحدود.',
      metric: 'كشف في الوقت الفعلي',
    },
    annotated: {
      title: 'صور مشروحة',
      description: 'احصل على تعليقات توضيحية مرئية مفصلة تسلط الضوء على الحالات المكتشفة مع مربعات الحدود والتسميات.',
      metric: 'وضوح بصري',
    },
    api: {
      title: 'واجهة برمجة تطبيقات عالية الأداء',
      description: 'مبني باستخدام FastAPI للحصول على أداء سريع وقابل للتطوير وسهولة التكامل مع أنظمة الويب والهاتف المحمول والمستشفيات.',
      metric: 'تكامل سريع',
    },
  },
  cases: {
    badge: 'التطبيقات السريرية',
    title: 'حلول شاملة للتصوير الطبي',
    subtitle: 'أنظمة كشف متقدمة مدعومة بالذكاء الاصطناعي تغطي تخصصات طبية متعددة بدقة سريرية وقدرات تحليل فورية.',
    detectionTypes: 'أنواع الكشف',
    keyFeatures: 'الميزات الرئيسية',
    aiDetection: 'الكشف بالذكاء الاصطناعي نشط',
    tryDemo: 'جرب العرض التفاعلي',
    
    // Detection type translations
    detectionTypeLabels: {
      // Fracture types
      elbow: 'الكوع',
      wrist: 'المعصم',
      shoulder: 'الكتف',
      humerus: 'العضد',
      forearm: 'الساعد',
      finger: 'الإصبع',
      
      // Knee grades
      normal: 'طبيعي',
      doubtful: 'مشكوك فيه',
      minimal: 'خفيف',
      moderate: 'متوسط',
      severe: 'شديد',
      
      // Lung conditions
      atelectasis: 'انخماص الرئة',
      cardiomegaly: 'تضخم القلب',
      effusion: 'الانصباب الجنبي',
      infiltrates: 'الارتشاحات',
      nodules: 'العقيدات',
      masses: 'الكتل',
      pneumonia: 'الالتهاب الرئوي',
      pneumothorax: 'استرواح الصدر',
      
      // Dental conditions
      caries: 'التسوس',
      crown: 'التاج',
      filling: 'الحشوة',
      implant: 'الزرعة',
      boneLoss: 'فقدان العظام',
      fracture: 'الكسر',
      
      // Cavity detection
      cavity: 'التجويف',
      normalTooth: 'سن طبيعي',
      
      // Scoliosis regions
      cervical: 'عنقي',
      thoracic: 'صدري',
      lumbar: 'قطني',
      sacral: 'عجزي',
    },
    
    fracture: {
      title: 'كشف كسور العظام',
      description: 'نظام كشف الكسور في الوقت الفعلي يعتمد على YOLO يغطي مناطق تشريحية متعددة بدقة عالية وتوصيات سريرية.',
      detectionLabel: 'تم اكتشاف كسر في المعصم',
      feature1Title: 'الكشف الفوري',
      feature1Desc: 'تحديد فوري للكسور مع تحديد الموقع ودرجات الثقة.',
      feature2Title: 'تغطية متعددة المناطق',
      feature2Desc: 'تحليل شامل عبر 6 مناطق تشريحية رئيسية بما في ذلك الأطراف العلوية والسفلية.',
      feature3Title: 'التكامل السريري',
      feature3Desc: 'تكامل سلس مع PACS مع إعداد تقارير آلية وتوصيات علاجية.',
    },
    
    knee: {
      title: 'كشف التهاب مفصل الركبة',
      description: 'نظام تصنيف مدعوم بـ EfficientNet-B5 يصنف التهاب مفصل الركبة إلى 5 درجات شدة للتخطيط العلاجي الدقيق.',
      detectionLabel: 'الدرجة 3 التهاب متوسط',
      feature1Title: 'تصنيف 5 درجات',
      feature1Desc: 'تقييم دقيق للشدة من طبيعي إلى شديد باستخدام أنظمة تصنيف سريرية معتمدة.',
      feature2Title: 'تتبع التقدم',
      feature2Desc: 'تحليل طولي لمراقبة تقدم المرض وفعالية العلاج بمرور الوقت.',
      feature3Title: 'إرشادات العلاج',
      feature3Desc: 'توصيات قائمة على الأدلة للتدخلات المحافظة أو الجراحية بناءً على الشدة.',
    },
    
    teeth: {
      title: 'كشف حالات الأسنان',
      description: 'نظام ذكاء اصطناعي شامل للأسنان يكتشف 31 حالة مختلفة من الأشعة السينية البانورامية لتقييم صحة الفم الكامل.',
      detectionLabel: 'تم اكتشاف حالات متعددة',
      feature1Title: '31 نوع حالة',
      feature1Desc: 'تغطية كاملة لأمراض الأسنان والترميمات والأجهزة التقويمية في فحص واحد.',
      feature2Title: 'التحليل البانورامي',
      feature2Desc: 'تقييم الفم الكامل مع تحديد دقيق لكل حالة مكتشفة وترقيم الأسنان.',
      feature3Title: 'تخطيط العلاج',
      feature3Desc: 'رسم بياني آلي للأسنان وإنشاء خطة علاج شاملة لسير عمل فعال.',
    },
    
    scoliosis: {
      title: 'كشف الجنف',
      description: 'نظام تحليل متقدم لانحناء العمود الفقري يغطي 4 مناطق فقرية مع قياس زاوية كوب للتشخيص الدقيق.',
      detectionLabel: 'انحناء صدري 28 درجة',
      feature1Title: 'قياس زاوية كوب',
      feature1Desc: 'حساب آلي لزوايا انحناء العمود الفقري بدقة عالية وقابلية للتكرار.',
      feature2Title: '4 مناطق فقرية',
      feature2Desc: 'تحليل كامل للمناطق العنقية والصدرية والقطنية والعجزية للتقييم الشامل.',
      feature3Title: 'تصنيف الشدة',
      feature3Desc: 'تصنيف تلقائي من خفيف إلى شديد مع توصيات علاجية وبروتوكولات مراقبة.',
    },
  },
  workflow: {
    label: 'كيف يعمل',
    title: 'خط أنابيب التحليل بالذكاء الاصطناعي',
    steps: {
      step1: {
        title: 'تحميل الصورة الطبية',
        description: 'يقدم المستخدم الأشعة السينية أو الصورة الطبية',
      },
      step2: {
        title: 'كشف الذكاء الاصطناعي',
        description: 'يحلل النموذج ويكتشف الحالات',
      },
      step3: {
        title: 'توليد النتائج',
        description: 'درجات الثقة والتعليقات التوضيحية',
      },
      step4: {
        title: 'تحليل مفصل',
        description: 'تقييم شامل للحالة',
      },
      step5: {
        title: 'دليل العلاج',
        description: 'توليد التوصيات',
      },
      step6: {
        title: 'إرجاع النتائج',
        description: 'صورة مشروحة واستجابة JSON',
      },
    },
    stats: {
      analysisTime: 'وقت التحليل',
      accuracyRate: 'معدل الدقة',
      automatedService: 'خدمة آلية',
    },
  },
  cta: {
    title: 'هل أنت مستعد لتحويل سير عملك التشخيصي؟',
    subtitle1: 'انضم إلى أكثر من 500 منشأة صحية',
    subtitle2: 'تستخدم تحليل الصور الطبية بالذكاء الاصطناعي',
    button: 'طلب تجربة',
  },
  demo: {
    badge: 'تجربة تفاعلية',
    title: 'شاهده أثناء العمل',
    subtitle: 'اختبر قوة تحليل الصور الطبية المدعوم بالذكاء الاصطناعي عبر حالات متعددة',
    selectCase: 'اختر حالة الذكاء الاصطناعي',
    uploadTitle: 'تحميل صورة طبية',
    uploadDesc: 'اسحب وأفلت أو انقر للتحميل',
    fileFormats: 'PNG, JPG, DICOM',
    minSize: 'الحد الأدنى 224×224 بكسل',
    sampleImage: 'صورة نموذجية',
    analyzeButton: 'تحليل الصورة',
    analyzing: 'جاري التحليل...',
    results: 'نتائج التحليل',
    aiOutput: 'مخرجات تحليل الذكاء الاصطناعي',
    confidence: 'الثقة',
    location: 'الموقع',
    condition: 'الحالة',
    tryDemo: 'جرب التجربة',
    readyToAnalyze: 'جاهز للتحليل',
    readyToAnalyzeDesc: 'قم بتحميل صورة طبية وانقر على "تحليل الصورة" لرؤية نتائج الكشف بالذكاء الاصطناعي',
    cases: {
      fracture: 'كشف الكسور',
      knee: 'التهاب مفصل الركبة',
      lung: 'تشوهات الرئة',
      scoliosis: 'كشف الجنف',
      teeth: 'الحالات السنية',
      cavity: 'كشف التسوس',
    },
  },
  contact: {
    title: 'تواصل معنا',
    subtitle: 'هل لديك أسئلة؟ نحن هنا لمساعدتك في دمج حلنا المدعوم بالذكاء الاصطناعي',
    name: 'الاسم الكامل',
    email: 'عنوان البريد الإلكتروني',
    message: 'رسالتك',
    send: 'إرسال الرسالة',
    sendWhatsApp: 'إرسال عبر واتساب',
    info: {
      title: 'معلومات الاتصال',
      email: 'info@5vix.com',
      phone: '+20 1044553254',
    },
    businessHours: {
      title: 'ساعات العمل',
      weekdays: 'الاثنين - الجمعة: 9:00 صباحاً - 6:00 مساءً',
      saturday: 'السبت: 10:00 صباحاً - 4:00 مساءً',
      sunday: 'الأحد: مغلق',
    },
  },
  footer: {
    newsletter: {
      title: 'ابق على اطلاع',
      subtitle: 'احصل على آخر التحديثات حول تقنية الذكاء الاصطناعي الطبية',
      placeholder: 'اكتب رسالتك',
      button: 'اشترك',
    },
    sendWhatsApp: 'إرسال عبر واتساب',
    quickLinks: 'روابط سريعة',
    contact: 'اتصل بنا',
    copyright: '© 2025 5vix. جميع الحقوق محفوظة.',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
    poweredBy: 'مدعوم من Debug',
  },
  predictions: {
    badge: 'تنبؤات الذكاء الاصطناعي',
    pageTitle: 'أدوات التنبؤ الطبي بالذكاء الاصطناعي',
    pageSubtitle: 'أدوات دعم القرار المتقدمة المدعومة بالذكاء الاصطناعي للمهنيين الصحيين. أدخل البيانات الرقمية للتحليل الفوري.',
    disclaimer: {
      title: 'دعم القرار الطبي فقط',
      text: 'هذه التنبؤات بالذكاء الاصطناعي مخصصة لمساعدة المهنيين الصحيين ولا ينبغي أن تحل محل التشخيص الطبي المهني. استشر دائماً الطاقم الطبي المؤهل للتشخيص النهائي وقرارات العلاج.',
    },
    common: {
      analyze: 'تحليل البيانات',
      analyzing: 'جاري التحليل...',
      results: 'نتائج التنبؤ',
      waitingForInput: 'أدخل بيانات المريض وانقر على تحليل لرؤية تنبؤات الذكاء الاصطناعي',
      processingAI: 'نموذج الذكاء الاصطناعي يعالج البيانات...',
      primaryPrediction: 'التنبؤ الرئيسي',
      allProbabilities: 'جميع احتمالات الحالات',
      confidence: 'الثقة',
      yes: 'نعم',
      no: 'لا',
    },
    heart: {
      title: 'حالة القلب (ECG)',
      subtitle: 'التنبؤ بحالات القلب بناءً على بيانات تخطيط القلب الرقمية',
      inputTitle: 'أدخل بيانات ECG والصحة',
      fields: {
        age: 'العمر (سنوات)',
        restingBP: 'ضغط الدم أثناء الراحة',
        cholesterol: 'الكوليسترول (mg/dL)',
        fastingBS: 'سكر الدم الصائم',
        maxHR: 'أقصى معدل ضربات القلب',
        oldpeak: 'انخفاض ST',
        restingECG: 'ECG أثناء الراحة',
        chestPain: 'نوع ألم الصدر',
        exerciseAngina: 'ذبحة صدرية أثناء التمرين',
        stSlope: 'ميل ST',
      },
      options: {
        ecgNormal: 'طبيعي',
        ecgST: 'شذوذ ST-T',
        ecgLVH: 'تضخم البطين الأيسر',
        painTypical: 'ذبحة صدرية نموذجية',
        painAtypical: 'ذبحة صدرية غير نموذجية',
        painNonAnginal: 'ألم غير ذبحي',
        painAsymptomatic: 'بدون أعراض',
        slopeUp: 'صاعد',
        slopeFlat: 'مسطح',
        slopeDown: 'هابط',
      },
      conditions: {
        normal: 'إيقاع جيبي طبيعي',
        arrhythmia: 'عدم انتظام ضربات القلب',
        heartDisease: 'مرض القلب التاجي',
        hypertension: 'قلب ارتفاع ضغط الدم',
        other: 'حالات أخرى',
      },
    },
    diabetes: {
      title: 'التنبؤ بالسكري',
      subtitle: 'تحديد خطر السكري بناءً على المؤشرات الصحية',
      inputTitle: 'أدخل المؤشرات الصحية',
      fields: {
        pregnancies: 'عدد مرات الحمل',
        glucose: 'الجلوكوز (mg/dL)',
        bloodPressure: 'ضغط الدم',
        skinThickness: 'سمك الجلد',
        insulin: 'الأنسولين (µU/mL)',
        bmi: 'مؤشر كتلة الجسم',
        diabetesPedigree: 'تاريخ السكري العائلي',
        age: 'العمر (سنوات)',
      },
      results: {
        diabetic: 'مصاب بالسكري',
        nonDiabetic: 'غير مصاب بالسكري',
        riskLevel: 'مستوى الخطر',
        risk: {
          low: 'خطر منخفض',
          moderate: 'خطر متوسط',
          high: 'خطر مرتفع',
        },
        recommendation: 'التوصية',
        recommendDiabetic: 'استشر طبيب الغدد الصماء لإدارة السكري الشاملة وتعديلات نمط الحياة.',
        recommendHealthy: 'حافظ على عادات نمط الحياة الصحية وجدول فحوصات صحية منتظمة.',
      },
    },
    anemia: {
      title: 'تنبؤ فقر الدم',
      subtitle: 'التنبؤ بنوع فقر الدم بناءً على معايير الدم ودراسات الحديد',
      inputTitle: 'أدخل معايير فقر الدم',
      basicParams: 'المعايير الأساسية',
      rbcIndices: 'مؤشرات كريات الدم الحمراء',
      ironStudies: 'دراسات الحديد',
      vitamins: 'مستويات الفيتامينات',
      fields: {
        hemoglobin: 'الهيموجلوبين',
        mcv: 'MCV',
        mch: 'MCH',
        mchc: 'MCHC',
        rdw: 'RDW',
        ferritin: 'الفيريتين',
        iron: 'الحديد في الدم',
        tibc: 'TIBC',
        vitaminB12: 'فيتامين B12',
        folate: 'حمض الفوليك',
      },
      severity: 'الشدة',
      severityLevels: {
        normal: 'طبيعي',
        mild: 'خفيف',
        moderate: 'متوسط',
        severe: 'شديد',
      },
      conditions: {
        normal: 'لم يتم اكتشاف فقر دم',
        ironDeficiency: 'فقر الدم بنقص الحديد',
        vitaminB12: 'فقر الدم بنقص فيتامين B12',
        folateDeficiency: 'فقر الدم بنقص حمض الفوليك',
        chronicDisease: 'فقر الدم المزمن',
        thalassemia: 'الثلاسيميا',
        hemolytic: 'فقر الدم الانحلالي',
        sideroblastic: 'فقر الدم الحديدي الأرومات',
        myelodysplastic: 'متلازمة خلل التنسج النقوي',
        alcoholRelated: 'فقر الدم المرتبط بالكحول',
        aplastic: 'فقر الدم اللاتنسجي',
      },
      clinicalNote: 'ملاحظة سريرية',
      clinicalNoteText: 'هذا التنبؤ يحدد النوع الأكثر احتمالاً لفقر الدم. تأكد بمسحة الدم المحيطية وعدد الخلايا الشبكية والفحوصات المتخصصة الإضافية.',
    },
    cbc: {
      title: 'تحليل CBC',
      subtitle: 'تفسير شامل لتعداد الدم الكامل',
      inputTitle: 'أدخل قيم CBC',
      rbcParams: 'معايير كريات الدم الحمراء',
      rbcIndices: 'مؤشرات كريات الدم الحمراء',
      wbcPlatelets: 'كريات الدم البيضاء والصفائح',
      differential: 'التعداد التفريقي لكريات الدم البيضاء',
      fields: {
        rbc: 'عدد كريات الدم الحمراء',
        hemoglobin: 'الهيموجلوبين',
        hematocrit: 'الهيماتوكريت',
        mcv: 'MCV',
        mch: 'MCH',
        mchc: 'MCHC',
        rdw: 'RDW',
        wbc: 'عدد كريات الدم البيضاء',
        platelets: 'الصفائح الدموية',
        neutrophils: 'العدلات',
        lymphocytes: 'الخلايا الليمفاوية',
        monocytes: 'الخلايا الوحيدة',
      },
      overallStatus: 'الحالة العامة',
      statusNormal: 'جميع القيم ضمن النطاق الطبيعي',
      statusAbnormal: 'تم اكتشاف قيم غير طبيعية',
      abnormalParams: 'معايير خارج النطاق الطبيعي',
      parameterResults: 'تحليل المعايير',
      ref: 'المرجع',
      status: {
        low: 'منخفض',
        normal: 'طبيعي',
        high: 'مرتفع',
      },
      clinicalNote: 'ملاحظة سريرية',
      clinicalNoteText: 'يقارن تحليل CBC هذا القيم مع النطاقات المرجعية القياسية. يجب ربط النتائج غير الطبيعية بالنتائج السريرية وقد تتطلب مزيداً من التحقيق.',
    },
    kidney: {
      title: 'وظائف الكلى',
      subtitle: 'التنبؤ بمرحلة مرض الكلى باستخدام قيم الكرياتينين واليوريا ومعدل الترشيح الكبيبي',
      inputTitle: 'أدخل معايير وظائف الكلى',
      coreParams: 'المعايير الأساسية',
      electrolytes: 'الإلكتروليتات',
      additional: 'معايير إضافية',
      fields: {
        creatinine: 'الكرياتينين',
        bun: 'نيتروجين يوريا الدم',
        gfr: 'معدل الترشيح الكبيبي',
        sodium: 'الصوديوم',
        potassium: 'البوتاسيوم',
        calcium: 'الكالسيوم',
        phosphorus: 'الفوسفور',
        albumin: 'الألبومين',
        uricAcid: 'حمض اليوريك',
        age: 'العمر (سنوات)',
      },
      severity: 'الشدة',
      severityLevels: {
        normal: 'طبيعي',
        mild: 'خفيف',
        moderate: 'متوسط',
        severe: 'شديد',
      },
      conditions: {
        normal: 'وظائف كلى طبيعية',
        stage1: 'المرحلة 1 - تلف كلوي مع معدل ترشيح طبيعي',
        stage2: 'المرحلة 2 - انخفاض خفيف في معدل الترشيح',
        stage3: 'المرحلة 3 - انخفاض متوسط في معدل الترشيح',
        stage4: 'المرحلة 4 - انخفاض شديد في معدل الترشيح',
        stage5: 'المرحلة 5 - فشل كلوي',
        aki: 'إصابة كلوية حادة',
      },
      clinicalNote: 'ملاحظة سريرية',
      clinicalNoteText: 'يقدر هذا التنبؤ مرحلة مرض الكلى المزمن بناءً على معدل الترشيح الكبيبي وعلامات الكلى. تأكد بتحليل البول والموجات فوق الصوتية للكلى والقياسات المتسلسلة على مدى 3 أشهر للتشخيص النهائي.',
    },
    liver: {
      title: 'وظائف الكبد',
      subtitle: 'تحليل اختبارات وظائف الكبد لتحديد حالات الكبد المحتملة',
      inputTitle: 'أدخل معايير وظائف الكبد',
      enzymes: 'إنزيمات الكبد',
      bilirubin: 'البيليروبين',
      proteins: 'البروتينات والتخثر',
      fields: {
        alt: 'ALT (SGPT)',
        ast: 'AST (SGOT)',
        alp: 'ALP',
        ggt: 'GGT',
        totalBilirubin: 'البيليروبين الكلي',
        directBilirubin: 'البيليروبين المباشر',
        albumin: 'الألبومين',
        totalProtein: 'البروتين الكلي',
        inr: 'INR',
        age: 'العمر (سنوات)',
      },
      severity: 'الشدة',
      severityLevels: {
        normal: 'طبيعي',
        mild: 'خفيف',
        moderate: 'متوسط',
        severe: 'شديد',
      },
      conditions: {
        normal: 'وظائف كبد طبيعية',
        fattyLiver: 'مرض الكبد الدهني غير الكحولي',
        hepatitis: 'التهاب الكبد المزمن',
        acuteHepatitis: 'التهاب الكبد الحاد',
        alcoholicLiver: 'مرض الكبد الكحولي',
        cirrhosis: 'تليف الكبد',
        cholestasis: 'ركود صفراوي',
        biliaryObstruction: 'انسداد القنوات الصفراوية',
        drugInduced: 'إصابة الكبد الدوائية',
        autoimmune: 'التهاب الكبد المناعي الذاتي',
      },
      clinicalNote: 'ملاحظة سريرية',
      clinicalNoteText: 'يقيم هذا التحليل علامات وظائف الكبد لتحديد الحالات المحتملة. تأكد من خلال دراسات التصوير (الموجات فوق الصوتية/الأشعة المقطعية)، ولوحة التهاب الكبد الفيروسي، وخزعة الكبد إذا لزم الأمر.',
    },
    thyroid: {
      title: 'وظائف الغدة الدرقية',
      subtitle: 'تحليل وظائف الغدة الدرقية باستخدام قيم TSH و T3 و T4 لتحديد اضطرابات الغدة الدرقية',
      inputTitle: 'أدخل معايير وظائف الغدة الدرقية',
      coreParams: 'المعايير الأساسية',
      freeHormones: 'الهرمونات الحرة',
      antibodies: 'الأجسام المضادة للغدة الدرقية',
      additional: 'معلومات إضافية',
      fields: {
        tsh: 'TSH',
        t3: 'T3 الكلي',
        t4: 'T4 الكلي',
        freeT3: 'T3 الحر',
        freeT4: 'T4 الحر',
        tpoAb: 'أجسام TPO المضادة',
        tgAb: 'أجسام الثيروجلوبولين المضادة',
        tsi: 'TSI',
        age: 'العمر (سنوات)',
      },
      severity: 'الشدة',
      severityLevels: {
        normal: 'طبيعي',
        mild: 'خفيف',
        moderate: 'متوسط',
        severe: 'شديد',
      },
      conditions: {
        normal: 'وظيفة الغدة الدرقية طبيعية',
        primaryHypo: 'قصور الغدة الدرقية الأولي',
        subclinicalHypo: 'قصور الغدة الدرقية تحت السريري',
        centralHypo: 'قصور الغدة الدرقية المركزي',
        primaryHyper: 'فرط نشاط الغدة الدرقية الأولي',
        subclinicalHyper: 'فرط نشاط الغدة الدرقية تحت السريري',
        hashimoto: 'التهاب الغدة الدرقية هاشيموتو',
        graves: 'مرض جريفز',
        thyroiditis: 'التهاب الغدة الدرقية',
        toxicNodule: 'تضخم الغدة الدرقية العقدي السام',
        sickEuthyroid: 'متلازمة الغدة الدرقية المريضة',
        drugInduced: 'اضطراب الغدة الدرقية الناجم عن الأدوية',
      },
      clinicalNote: 'ملاحظة سريرية',
      clinicalNoteText: 'يحلل هذا التنبؤ مستويات هرمونات الغدة الدرقية والأجسام المضادة لتحديد اضطرابات الغدة الدرقية المحتملة. تأكد من خلال الموجات فوق الصوتية للغدة الدرقية، ومسح امتصاص اليود المشع، والارتباط السريري للتشخيص النهائي.',
    },
    lipid: {
      title: 'صورة الدهون',
      subtitle: 'تحليل مستويات الكوليسترول والدهون لتقييم مخاطر القلب والأوعية الدموية',
      inputTitle: 'أدخل قيم لوحة الدهون',
      coreLipids: 'لوحة الدهون الأساسية',
      additionalMarkers: 'علامات إضافية',
      advancedMarkers: 'علامات متقدمة',
      fields: {
        totalCholesterol: 'الكوليسترول الكلي',
        ldl: 'كوليسترول LDL',
        hdl: 'كوليسترول HDL',
        triglycerides: 'الدهون الثلاثية',
        vldl: 'VLDL',
        nonHdl: 'الكوليسترول غير HDL',
        apoB: 'أبوليبوبروتين B',
        lpA: 'ليبوبروتين (أ)',
        age: 'العمر (سنوات)',
      },
      cardiovascularRisk: 'مخاطر القلب والأوعية الدموية',
      riskScore: 'درجة الخطر',
      riskLevels: {
        low: 'خطر منخفض',
        moderate: 'خطر متوسط',
        high: 'خطر مرتفع',
        very_high: 'خطر مرتفع جداً',
      },
      calculatedRatios: 'النسب المحسوبة',
      ratios: {
        tcHdl: 'TC/HDL',
        ldlHdl: 'LDL/HDL',
        tgHdl: 'TG/HDL',
      },
      parameterResults: 'تحليل معايير الدهون',
      target: 'الهدف',
      status: {
        optimal: 'مثالي',
        borderline: 'حدي',
        high: 'مرتفع',
        low: 'منخفض',
      },
      clinicalNote: 'ملاحظة سريرية',
      clinicalNoteText: 'يقيم تحليل صورة الدهون هذا مخاطر القلب والأوعية الدموية بناءً على مستويات الكوليسترول والنسب. قد يوصى بتعديلات نمط الحياة والعلاج بالستاتين بناءً على تقييم المخاطر الشامل.',
    },
    urinalysis: {
      title: 'تحليل البول',
      subtitle: 'تحليل شامل للبول لتقييم الكلى والتمثيل الغذائي والمسالك البولية',
      inputTitle: 'أدخل قيم تحليل البول',
      physical: 'الخصائص الفيزيائية',
      chemical: 'الاختبارات الكيميائية',
      infection: 'علامات العدوى',
      microscopic: 'الفحص المجهري',
      fields: {
        color: 'اللون',
        clarity: 'الصفاء',
        specificGravity: 'الكثافة النوعية',
        ph: 'الحموضة',
        protein: 'البروتين',
        glucose: 'الجلوكوز',
        ketones: 'الكيتونات',
        blood: 'الدم',
        leukocytes: 'إستراز الكريات البيضاء',
        nitrites: 'النتريت',
        bilirubin: 'البيليروبين',
        urobilinogen: 'اليوروبيلينوجين',
        rbc: 'كريات الدم الحمراء',
        wbc: 'كريات الدم البيضاء',
        bacteria: 'البكتيريا',
        casts: 'الأسطوانات',
      },
      options: {
        color: {
          pale: 'أصفر فاتح',
          yellow: 'أصفر',
          dark_yellow: 'أصفر داكن',
          amber: 'كهرماني',
          red: 'أحمر/وردي',
          brown: 'بني',
        },
        clarity: {
          clear: 'صافي',
          slightly_cloudy: 'غائم قليلاً',
          cloudy: 'غائم',
          turbid: 'عكر',
        },
        qualitative: {
          negative: 'سلبي',
          trace: 'أثر',
          '1plus': '+1',
          '2plus': '+2',
          '3plus': '+3',
          positive: 'إيجابي',
        },
        urobilinogen: {
          normal: 'طبيعي',
          elevated: 'مرتفع',
        },
      },
      refs: {
        color: 'فاتح إلى أصفر',
        clarity: 'صافي',
        negative: 'سلبي',
        urobilinogen: 'طبيعي (0.2-1.0)',
      },
      parameterResults: 'تحليل المعايير',
      conditions: {
        normal: 'تحليل بول طبيعي',
        uti: 'عدوى المسالك البولية',
        proteinuria: 'بيلة بروتينية',
        glucosuria: 'بيلة سكرية',
        hematuria: 'بيلة دموية',
        ketonuria: 'بيلة كيتونية',
        bilirubinuria: 'بيلة بيليروبينية',
      },
      clinicalNote: 'ملاحظة سريرية',
      clinicalNoteText: 'يحدد تفسير تحليل البول هذا حالات المسالك البولية أو الكلى أو التمثيل الغذائي المحتملة. يجب تأكيد النتائج غير الطبيعية بزراعة البول والفحص المجهري والاختبارات الإضافية حسب الحاجة.',
    },
  },
};
